import { CreditCardType } from '@anm/api/modules/subscription';
import { FC } from 'react';
import styled from 'styled-components';

import CardBlock from '../CardBlock';
import DotsCardNumber from '../DotsCardNumber';

export type CardDetailsProps = {
  last4: string;
  cardType: CreditCardType;
};

const CardDetailsWrapper = styled.div`
  margin-bottom: 0;
  border: 1px solid #cbdce5;
  width: 100%;
  padding: 20px 10px;
  border-radius: 5px;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ebeef5;
`;

const CardDetails: FC<CardDetailsProps> = ({ cardType, last4 }) => (
  <CardDetailsWrapper>
    <CardBlock cardType={cardType} />
    <DotsCardNumber last4={last4} />
  </CardDetailsWrapper>
);

export default CardDetails;
